import type { Theme } from '../../core/theme';
import { gridThemeParse } from './component/grid';
import { xAxisThemeParse } from './component/xAxis';
import { yAxisThemeParse } from './component/yAxis';
import { graphicThemeParse } from './component/graphic';
import { animationThemeParse } from './component/animation';
import { dynamicBarThemeParse } from './series/dynamicBar';
import { treemapThemeParse } from './series/treemap';
import { sankeyThemeParse } from './series/sankey';
import { dvScatterThemeParse } from './series/dvScatter';
import { pcLineThemeParse } from './series/line';
import { pcBarThemeParse } from './series/bar';
import { voronoiThemeParse } from './series/voronoi';
import defaultThemeConfig from '../util/presetOptionToken';

// 问财动态条形图、矩形树图、气泡图
export const pcWencaiLight = {
  name: 'pc-wencai-light' as const,
  presetOptionToken: defaultThemeConfig.shouchao,
  parsers: [
    // series -------------------------------------------------------
    dynamicBarThemeParse,
    treemapThemeParse,
    dvScatterThemeParse,

    // component -------------------------------------------------------
    gridThemeParse,
    xAxisThemeParse,
    yAxisThemeParse,
    graphicThemeParse,
    animationThemeParse
  ]
} as Theme;

export const pcAppLight = {
  name: 'pc-app-light' as const,
  presetOptionToken: defaultThemeConfig.shouchao,
  parsers: [
    // series -------------------------------------------------------
    pcBarThemeParse,
    pcLineThemeParse,
    sankeyThemeParse,
    dvScatterThemeParse,
    voronoiThemeParse,
    dvScatterThemeParse
  ]
} as Theme;

export const pcAppDark = {
  name: 'pc-app-dark' as const,
  presetOptionToken: defaultThemeConfig.shouchao,
  parsers: [
    // series -------------------------------------------------------
    dynamicBarThemeParse,
    pcBarThemeParse,
    pcLineThemeParse
  ]
} as Theme;
